export default __webpack_public_path__ + "static/media/fridge2-beforeA-768w.566469bb.webp";